<template>
  <v-container grid-list-md text-xs-center>
    <TabArchivedCourse />
    <TableArchivedCourse />
    <CourseDetial />
  </v-container>
</template>

<script>
import TabArchivedCourse from "../components/Tabs/TabArchivedCourse";
import TableArchivedCourse from "../components/Tables/TableArchivedCourse";
import CourseDetial from "../components/CourseDetial";

export default {
  components: {
    TabArchivedCourse,
    TableArchivedCourse,
    CourseDetial,
  },
  mounted() {
    this.$store.commit("clearInfo");
  },
};
</script>
